"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var OpenTreePropertyDefinitionDialogModule = /** @class */ (function () {
    function OpenTreePropertyDefinitionDialogModule() {
    }
    return OpenTreePropertyDefinitionDialogModule;
}());
exports.OpenTreePropertyDefinitionDialogModule = OpenTreePropertyDefinitionDialogModule;
